import { render } from "./TabBill.vue?vue&type=template&id=3a829e56&scoped=true"
import script from "./TabBill.vue?vue&type=script&lang=js"
export * from "./TabBill.vue?vue&type=script&lang=js"

import "./TabBill.vue?vue&type=style&index=0&id=3a829e56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a829e56"]])

export default __exports__